/**
 * This file contains various getter methods that can be used in different Web Components
 */

import { CompanyActionContext } from '../company/common/types/CompanyActionContext';

export function getContext(): CompanyActionContext {
  const context = this.getAttribute('context');

  if (!CompanyActionContext.isValid(context)) {
    throw new Error(`CompanyDetailsForm context not valid: ${context}`);
  }

  return context as CompanyActionContext;
}
